import { createContext, useContext, useState } from "react";
import { Box, IconButton, Modal, Typography, Fade, Backdrop } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import useStyles from "../../pages/attribution/modal/ModalAttributionStyle";

export const ModalContext = createContext({});
export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [modalContent, setModalContent] = useState(null);
  const [title, setTitle] = useState("");
  const [open, setOpen] = useState(false);  
  const [style, setStyle] = useState({});
  const [closeCallback, setCloseCallback] = useState(null); // Ajout du callback
  const classes = useStyles()();

  const openModal = (title = "", content, style={}, callback = null) => {
    setTitle(title);
    setModalContent(content);
    setStyle(style);
    setCloseCallback(() => callback); // Stocke le callback à appeler lors de la fermeture
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setModalContent(null);
    setTitle("");
    if (typeof closeCallback === 'function') {
      closeCallback(); // Appelle le callback si défini
    }
    setCloseCallback(null); // Réinitialiser le callback après exécution
  };

  return (
    <ModalContext.Provider value={{ openModal, closeModal, isOpen: open }}>
      {children}
      <Modal
        onClose={closeModal}
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Fade in={open}>
          <div className={classes.paper} style={style}>
            <div className={classes.header}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6" className={classes.title}>
                  {title}
                </Typography>
                <IconButton onClick={closeModal} className={classes.closeButton}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </div>
            <div className={classes.content}>{modalContent}</div>
          </div>
        </Fade>
      </Modal>
    </ModalContext.Provider>
  );
};
